module.exports = __webpack_public_path__ + "static/img/login_white.d120f57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_white.svg
// module id = tdR7
// module chunks = 13